<template>
    <form method="POST" action="/abschluss">
        <csrf />

        <section class="order">
            <div class="container">
                <div class="order__heading">
                    {{ trans('orders.summary.title') }}
                </div>

                <div class="order__description">
                    {{ trans('orders.summary.description') }}
                </div>

                <div class="order__summary">
                    <div class="order-summary">
                        <div class="order-summary__section">
                            <div class="order-summary__section-heading">
                                {{ trans('orders.summary.general_information') }}
                            </div>

                            <div class="order-summary__section-box">
                                <div class="font-weight-bold">{{ order.name }}</div>
                                <div>{{ trans('orders.form.email') }}: {{ order.email }}</div>
                                <div>{{ trans('orders.form.phone') }}: {{ order.phone }}</div>
                            </div>
                        </div>

                        <div class="order-summary__section">
                            <div class="order-summary__section-heading">
                                {{ trans('orders.summary.billing_information') }}
                            </div>

                            <div class="order-summary__section-box">
                                <div class="font-weight-bold">{{ order.company }}</div>
                                <div>{{ order.address }}</div>
                                <div>{{ order.zip }} {{ order.city }}</div>
                            </div>
                        </div>

                        <div class="order-summary__section">
                            <div class="order-summary__section-heading">
                                {{ trans('orders.summary.order_information') }}
                            </div>

                            <div class="order-summary__section-box">
                                <div class="font-weight-bold">{{ trans('orders.summary.license_amount') }}: {{ order.license_count }}</div>
                                <br/>
                                <div class="font-weight-bold">{{ trans('orders.summary.themes') }}: </div>

                                <ul>
                                    <li v-for="product in order.products" :key="product.id">{{ product.title }}</li>
                                </ul>
                            </div>

                            <div class="order-summary__section-footer">
                                <span class="font-weight-bold">
                                    {{ trans('orders.summary.total_price') }}: {{ totalPriceFormatted }}
                                </span>
                                <span class="order-summary--unhighlighted">
                                    {{ trans('orders.summary.excl_vat') }}
                                </span>
                            </div>

                            <alert-box class="mt-4 alert-box--full-width">{{ trans('orders.summary.subscription_note') }}</alert-box>
                        </div>

                        <div class="order-summary__section">
                            <div class="order-summary__section-heading">
                                {{ trans('orders.summary.contract_information') }}
                            </div>

                            <div class="order-summary__section-box order-summary__section-box--without-bg-color">
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" checked class="custom-control-input" v-model="shouldRenew" id="should_renew_true" name="should_renew" :value="1">
                                    <label class="custom-control-label" for="should_renew_true">{{ trans('orders.summary.should_renew') }}</label>
                                </div>

                                <div class="custom-control custom-radio mb-4">
                                    <input type="radio" class="custom-control-input" v-model="shouldRenew" id="should_renew_false" name="should_renew" :value="0">
                                    <label class="custom-control-label" for="should_renew_false">{{ trans('orders.summary.should_not_renew') }}</label>
                                </div>

                                <alert-box v-if="shouldRenew" class="alert-box--full-width">{{ trans('orders.summary.should_renew_note') }}</alert-box>
                                <alert-box v-if="!shouldRenew" class="alert-box--full-width">{{ trans('orders.summary.should_not_renew_note') }}</alert-box>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="order-summary__checkboxes">
                    <checkbox class="mb-2" name="terms_of_use" v-model="termsOfUse"><span v-html="trans('orders.summary.terms_of_use')"></span></checkbox>

                    <checkbox class="mb-4" name="license_terms" v-model="licenseTerms"><span v-html="trans('orders.summary.license_terms')"></span></checkbox>
                </div>

                <page-control :label="trans('page-control.submit_order')" button margin-bottom></page-control>
            </div>
        </section>

        <input type="hidden" name="firstname" :value="order.firstname">
        <input type="hidden" name="lastname" :value="order.lastname">
        <input type="hidden" name="subscription_number" :value="order.subscription_number">
        <input type="hidden" name="email" :value="order.email">
        <input type="hidden" name="phone" :value="order.phone">
        <input type="hidden" name="company" :value="order.company">
        <input type="hidden" name="is_po_box" :value="order.is_po_box">
        <input type="hidden" name="address" :value="order.address">
        <input type="hidden" name="zip" :value="order.zip">
        <input type="hidden" name="city" :value="order.city">
        <input type="hidden" name="license_count" :value="order.license_count">
        <input v-for="product in order.products" :key="product.id" type="hidden" name="products[]" :value="product.id">
    </form>
</template>

<script>
export default {
    props: {
        order: Object,
        totalPrice: Number,
    },

    data() {
        return {
            shouldRenew: 1,
            termsOfUse: false,
            licenseTerms: false,
        };
    },

    computed: {
        totalPriceFormatted() {
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.totalPrice);
        }
    },
}
</script>
